import React, { useState, useEffect } from 'react';
import NavBar from './navbar';
import { Outlet } from 'react-router-dom';
import Footer from './footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import portfolioData from '../data/drive_images.json';

const Layout = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('qoncave-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = savedTheme || (prefersDark ? 'dark' : 'light');
    setTheme(initialTheme);
    document.documentElement.classList.toggle('dark', initialTheme === 'dark');
  }, []);

  useEffect(() => {
    const allPortfolioImages = Object.values(portfolioData).flat();
    allPortfolioImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const toggleTheme = () => {
    setTheme((current) => {
      const nextTheme = current === 'dark' ? 'light' : 'dark';
      document.documentElement.classList.toggle('dark', nextTheme === 'dark');
      localStorage.setItem('qoncave-theme', nextTheme);
      return nextTheme;
    });
  };
  return (
    <HelmetProvider>
      <div className="font-Poppins transition-colors duration-300 bg-white text-slate-950 dark:bg-slate-950 dark:text-slate-100">
        {/* Default SEO tags - these show up if a specific page doesn't define its own */}
        <Helmet>
          <title>Qoncave | POP & Construction Services in Nigeria and West Africa</title>
          <link rel="canonical" href="https://qoncave.com/" />
          <meta name="description" content="Qoncave delivers premium POP installation, gypsum plasterboard, dry wall partitioning, concrete designs, and wall screeding across Nigeria and West Africa." />
          <meta name="keywords" content="POP installation Nigeria, POP ceiling installation West Africa, construction Nigeria, concrete design Nigeria, gypsum plasterboard, dry wall partitioning, wall screeding, interior design Lagos" />
          <meta name="robots" content="index, follow" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://qoncave.com/" />
          <meta property="og:site_name" content="Qoncave" />
          <meta property="og:title" content="Qoncave | POP & Construction Services in Nigeria and West Africa" />
          <meta property="og:description" content="Qoncave delivers premium POP installation, gypsum plasterboard, dry wall partitioning, concrete designs, and wall screeding across Nigeria and West Africa." />
          <meta property="og:image" content="https://qoncave.com/og-image.png" />
          <meta property="og:locale" content="en_NG" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Qoncave | POP & Construction Services in Nigeria and West Africa" />
          <meta name="twitter:description" content="Qoncave delivers premium POP installation, gypsum plasterboard, dry wall partitioning, concrete designs, and wall screeding across Nigeria and West Africa." />
          <meta name="twitter:image" content="https://qoncave.com/og-image.png" />
          <meta name="twitter:image:alt" content="Qoncave premium construction and POP installation" />
          <meta name="twitter:site" content="@Qoncave" />

          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "HomeAndConstructionBusiness",
                "name": "Qoncave",
                "image": "https://qoncave.com/qoncave-interior-design-hero.jpeg",
                "description": "Premium interior and exterior construction services in Nigeria and West Africa.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Abeokuta",
                  "addressCountry": "NG"
                },
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Construction & Design Services",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Gypsum Plaster Board & POP Ceiling Installation"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Concrete Interior and Exterior Designs"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Dry Wall Partitioning"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Screeding, Consoles and Wall Finishes"
                      }
                    }
                  ]
                }
              }
            `}
          </script>
        </Helmet>

        <NavBar theme={theme} toggleTheme={toggleTheme} />
        
        <main>
          <Outlet />
        </main>
        
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;